export default __webpack_public_path__ + "static/media/lock-24px@2x.338a508f.png";